import React, { useState } from 'react'

import { Button } from '@/components/buttons/Button'

export const TaskDrawerFooter = ({
  primaryActionButtonText,
  primaryButtonDisabled,
  handlePrimaryAction,
  secondaryActionButtonText,
  handleSecondaryAction,
}) => {
  const [actionInProgress, setActionInProgress] = useState(false)

  const handlePrimaryClick = async () => {
    setActionInProgress(true)
    try {
      if (handlePrimaryAction) {
        await handlePrimaryAction()
      }
    } finally {
      setActionInProgress(false)
    }
  }

  const handleSecondaryClick = async () => {
    setActionInProgress(true)
    try {
      if (handleSecondaryAction) {
        await handleSecondaryAction()
      }
    } finally {
      setActionInProgress(false)
    }
  }

  return (
    <div className="drawer-footer">
      <div className="flex-align-center flex-end">
        <div className="flex-align-center medium-gap">
          {handleSecondaryAction && (
            <Button
              onClick={handleSecondaryClick}
              data-testid="drawer-secondary-action"
              disabled={actionInProgress}
              loading={actionInProgress}
            >
              {secondaryActionButtonText}
            </Button>
          )}
          {handlePrimaryAction && (
            <Button
              brand
              onClick={handlePrimaryClick}
              data-testid="drawer-primary-action"
              disabled={primaryButtonDisabled || actionInProgress}
              loading={actionInProgress}
            >
              {primaryActionButtonText}
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}
